export const XING_URL = 'https://www.xing.com';
export const PEOPLE_DIRECTORY_ROUTE = '/people/';
export const CITIES_LISTING_PAGE = `${PEOPLE_DIRECTORY_ROUTE}cities/`;
